import React, { PureComponent, createRef } from "react";
import { Link } from "react-router-dom";
import ExternalAccount from "../../../common/externalAccount/ExternalAccount";
import Svg from "../../../common/svgIcon";
import SwitchBookmakerButtons from "./SwitchBookmakerButtons";
import classnames from "classnames";
import SignUpOfferPage from "../../signUpOfferPage";
import SkybetLogo from "./SkyBetLogo";
import { BOOKMAKERS_QUIZ } from "../../../common/bookmakersList/bookmakersList.constants";
import "./styles.scss";
import { isSkybetMigrationEnabled, skybetApiName } from "../../../common/utils/skybetMigration";

export default class BookmakersListItem extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			isOfferVisible: false,
			isSkybetPageInfoOpen: false,
			existingBookmakerAccounts: [],
		};

		this.skyBetButtonHistoryRef = createRef();
		this.offerButtonRef = createRef();
		this.isSkybetMigrationEnabled = isSkybetMigrationEnabled;
	}

	toggleRegistrationOffer = () => {
		this.setState((prevState) => ({
			isOfferVisible: !prevState.isOfferVisible,
		}));

		const { analyticsName, bookmakerIndex, registrationOfferHeadline } = this.props;

		window.SegmentIO.trackOfferAccordion({
			[SegmentIO.TRAIT_BOOKMAKER_NAME]: analyticsName,
			[SegmentIO.TRAIT_OFFERS_BANNER]: null,
			[SegmentIO.TRAIT_BOOKMAKER_OFFER]: registrationOfferHeadline,
			[SegmentIO.TRAIT_POSITION]: bookmakerIndex + 1,
		});
	};

	// eslint-disable-next-line consistent-return
	toggleMobileRegistrationoffer = (registrationOffer, isOfferActive) => {
		if (!registrationOffer) {
			return false;
		}

		const { analyticsName, bookmakerIndex, registrationOfferHeadline, toggleBookmakerOffer } =
			this.props;

		toggleBookmakerOffer(isOfferActive ? null : bookmakerIndex);

		window.SegmentIO.trackOfferAccordion({
			[SegmentIO.TRAIT_BOOKMAKER_NAME]: analyticsName,
			[SegmentIO.TRAIT_OFFERS_BANNER]: null,
			[SegmentIO.TRAIT_BOOKMAKER_OFFER]: registrationOfferHeadline,
			[SegmentIO.TRAIT_POSITION]: bookmakerIndex + 1,
		});
	};

	toggleSkyBetInfoPage = () => {
		this.setState((prevState) => ({
			isSkybetPageInfoOpen: !prevState.isSkybetPageInfoOpen,
		}));
	};

	handleOutsideClick = (e) => {
		if (
			this.offerButtonRef &&
			this.offerButtonRef.current &&
			!this.offerButtonRef.current.contains(e.target)
		) {
			this.setState({
				isOfferVisible: false,
			});
		}

		if (
			this.skyBetButtonHistoryRef &&
			this.skyBetButtonHistoryRef.current &&
			!this.skyBetButtonHistoryRef.current.contains(e.target)
		) {
			this.setState({
				isSkybetPageInfoOpen: false,
			});
		}
	};

	onLogoutClick = () => {
		if (
			this.props.selectedBets.length > 0 &&
			// eslint-disable-next-line react/prop-types
			this.props.selectedBets[0].feed === this.props.feed
		) {
			this.props.clearSelectedBets();
			this.props.clearMultiples();
			this.props.resetEmptyBetslip();
		}
		this.props.requestLogout(this.props.apiName, this.props.feed, this.props.isExternalLogout);
	};

	handleCreateAccountClick = (event) => {
		event.stopPropagation();
		const { analyticsName, bookmakerIndex, registrationOfferHeadline } = this.props;

		window.SegmentIO.trackBookmakerRegistrationTap({
			[SegmentIO.TRAIT_BOOKMAKER_NAME]: analyticsName,
			[SegmentIO.TRAIT_OFFERS_BANNER]: null,
			[SegmentIO.TRAIT_BOOKMAKER_OFFER]: registrationOfferHeadline,
			[SegmentIO.TRAIT_POSITION]: bookmakerIndex + 1,
		});
	};

	componentDidMount = () => {
		document.addEventListener("mousedown", this.handleOutsideClick);

		if (this.props.apiName === skybetApiName && this.props.getExternalBetHistoryUrl) {
			this.props.getExternalBetHistoryUrl(this.props.apiName);
		}

		const userTraits = JSON.parse(localStorage.getItem("__user_traits") || "{}");
		const recentBookmakers = JSON.parse(localStorage.getItem("recentBookmakers") || "{}");

		const quizBookmakerAccounts = BOOKMAKERS_QUIZ.filter((key) => Boolean(userTraits[key])).map(
			(key) => key.replace("_quiz", "").replaceAll("_", "")
		);
		const filteredRencetBookmakers = Object.keys(recentBookmakers).map((key) =>
			key.replaceAll("_", "")
		);
		const excludedBookmakers = new Set([...quizBookmakerAccounts, ...filteredRencetBookmakers]);
		this.setState({ existingBookmakerAccounts: Array.from(excludedBookmakers) });
	};

	componentWillUnmount = () => {
		document.removeEventListener("mousedown", this.handleOutsideClick);
	};

	render() {
		const {
			bookmakerIndex,
			isLoginLeftPositioned,
			name,
			feed,
			isLoggedIn,
			registrationOffer,
			registrationLink,
			registrationOfferLinkUrl,
			userInfo,
			apiName,
			bookmakersList,
			registrationOfferHeadline,
			registrationOfferLinkText,
			registrationOfferDetailsLink,
			withdrawBookmakerUrl,
			isWindowLogin,
			activeBookmakerOfferIndex,
			externalBetHistoryUrl,
			isExternalBetHistoryError,
		} = this.props;

		// NOTE: [JP-9947] isExistingBookmakerAccount present quiz results from user
		// sign where they have bookmaker account
		const isExistingBookmakerAccount = this.state.existingBookmakerAccounts.includes(
			name.toLowerCase()
		);
		const isOfferActive = activeBookmakerOfferIndex === bookmakerIndex;

		return (
			<div
				className='root__bookmakersContentBox'
				data-test-selector={`Container__${name}__Bookmaker`}
			>
				<div className='root__bookmakersContentMain'>
					<div className='root__bookmakersContentLeft'>
						<span
							className='root__bookmakersContentLeftLogo'
							data-test-selector={`Image__${name}__BookmakerLogo`}
						>
							{name === "skybet" ? (
								<SkybetLogo />
							) : (
								<Svg iconName={name} size='8XL' />
							)}
						</span>
						{!isLoggedIn ? (
							<div
								className='root__bookmakersContentLeftOffers'
								ref={this.offerButtonRef}
								data-test-selector={`Container__${name}__BookmakerOffer`}
							>
								{registrationOffer && !isExistingBookmakerAccount && (
									<React.Fragment>
										<div
											className='root__bookmakerOffer'
											onClick={this.toggleRegistrationOffer}
											data-test-selector={`Button__${name}__ToggleBookmakerOffer`}
										>
											<Svg iconName='info-aqua' size='regular' />
											{this.state.isOfferVisible && (
												<SignUpOfferPage
													offerHeadline={registrationOfferHeadline}
													offerContent={registrationOffer}
													offerLink={registrationOfferDetailsLink}
													buttonText={registrationOfferLinkText}
													defaultBookmakerUrl={withdrawBookmakerUrl}
													analyticsRegistrationClick={
														this.handleCreateAccountClick
													}
												/>
											)}
										</div>
										<span
											className='root__bookmakersPageTextContent'
											data-test-selector={`Text__${name}__BookmakerOfferHeadline`}
										>
											{registrationOfferHeadline}
										</span>
									</React.Fragment>
								)}
							</div>
						) : (
							<div
								className='root__bookmakersAccountBalance'
								data-test-selector={`Container__${name}__BookmakerAccount`}
							>
								{name === "skybet" && !this.isSkybetMigrationEnabled ? (
									<React.Fragment>
										<span
											className='root__bookmakersBetHistory'
											onClick={this.toggleSkyBetInfoPage}
											ref={this.skyBetButtonHistoryRef}
											data-test-selector={`Button__${name}__BookmakerBetHistory`}
										>
											Bet History{" "}
											<Svg iconName='chevronRight' size='regular' />
										</span>
										{this.state.isSkybetPageInfoOpen && (
											<ExternalAccount
												type='window'
												windowName={"History"}
												externalAccountUrl={externalBetHistoryUrl}
												isExternalAccountError={
													isExternalBetHistoryError
												}
												onExternalBackButtonClick={
													this.toggleSkyBetInfoPage
												}
											/>
										)}
									</React.Fragment>
								) : (
									<Link
										to={`${feed}/bethistory`}
										className='root__bookmakersBetHistory'
										data-test-selector={`Link__${name}__BookmakerBetHistory`}
									>
										Bet History <Svg iconName='chevronRight' size='regular' />
									</Link>
								)}
								<div className='root__bookmakersBalance'>
									<span data-test-selector='Text__BookmakerBalance'>Balance</span>
									<span data-test-selector={`Text__${name}__BookmakerBalance`}>
										{userInfo.currencySign}
										{userInfo.balance}
									</span>
								</div>
							</div>
						)}
					</div>
					<div className='root__bookmakersContentRight'>
						<SwitchBookmakerButtons
							apiName={apiName}
							isLoggedIn={isLoggedIn}
							registrationLink={registrationLink}
							registrationOfferLinkUrl={registrationOfferLinkUrl}
							onLogout={this.onLogoutClick}
							analyticsRegistrationClick={this.handleCreateAccountClick}
							isLoginLeftPositioned={isLoginLeftPositioned}
							bookmakersList={bookmakersList}
							feed={feed}
							name={name}
							withdrawBookmakerUrl={withdrawBookmakerUrl}
							isWindowLogin={isWindowLogin}
							shouldShowSignUp={!isExistingBookmakerAccount}
						/>
						{!isLoggedIn && !isExistingBookmakerAccount && (
							<div
								className={classnames("root__bookmakersMobileOfferBtn", {
									root__bookmakersMobileOfferToggled: isOfferActive,
								})}
								onClick={() =>
									this.toggleMobileRegistrationoffer(
										registrationOffer,
										isOfferActive
									)
								}
								data-test-selector={`Button__${name}__ToggleMobileBookmakerOffer`}
							>
								<span>SIGN UP {registrationOffer && "OFFER"}</span>
								<Svg iconName='chevronDown' size='SmallPlus' />
							</div>
						)}
					</div>
				</div>
				{!isLoggedIn && registrationOffer && isOfferActive && (
					<div
						className='root__bookmakersMobileOfferWrapper'
						data-test-selector={`Container__${name}__BookmakerMobileOffer`}
					>
						<SignUpOfferPage
							offerHeadline={registrationOfferHeadline}
							offerContent={registrationOffer}
							offerLink={registrationOfferDetailsLink}
							buttonText={registrationOfferLinkText}
							defaultBookmakerUrl={withdrawBookmakerUrl}
							analyticsRegistrationClick={this.handleCreateAccountClick}
						/>
					</div>
				)}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// /src/js/bookmakersSwitcher/chooseBookmakerPage/components/BookmakersListItem.jsx